<div class="w-full max-w-[1440px] mx-auto h-full flex flex-col pb-20 pt-14">
  <router-outlet></router-outlet>
</div>
